export default function checkHands(cards) {
  // Берём все комбинации по 5 карт
  const all5 = combinations(cards, 5);

  let best = null;

  for (const hand of all5) {
    const rank = evaluate(hand);
    if (!best || compareRanks(rank, best) > 0) {
      best = rank;
    }
  }

  return best;
}

// -----------------------
// Оценка конкретной 5-картовой руки
// -----------------------
function evaluate(hand) {
  const ranks = hand.map((c) => c[0]).sort((a, b) => a - b);
  const suits = hand.map((c) => c[1]);

  // Частоты рангов
  const count = {};
  for (const r of ranks) count[r] = (count[r] || 0) + 1;

  const groups = Object.entries(count)
    .map(([r, c]) => ({ rank: Number(r), count: c }))
    .sort((a, b) => b.count - a.count || b.rank - a.rank);

  const isFlush = new Set(suits).size === 1;

  // Straight: с учётом A-5
  const isStraight = (() => {
    let unique = [...new Set(ranks)];
    if (unique.length !== 5) return false;

    // Обычная последовательность
    if (unique[4] - unique[0] === 4) return unique[4];

    // A-2-3-4-5 (12,0,1,2,3)
    if (JSON.stringify(unique) === JSON.stringify([0, 1, 2, 3, 12])) {
      return 3; // значение straight = 5
    }
    return false;
  })();

  // Royal flush
  if (isFlush && isStraight === 12) {
    return { rank: 9, name: "Royal Flush", tiebreak: [12] };
  }

  // Straight flush
  if (isFlush && isStraight !== false) {
    return { rank: 8, name: "Straight Flush", tiebreak: [isStraight] };
  }

  // Four of a kind
  if (groups[0].count === 4) {
    return {
      rank: 7,
      name: "Four of a Kind",
      tiebreak: [groups[0].rank, groups[1].rank],
    };
  }

  // Full house
  if (groups[0].count === 3 && groups[1].count === 2) {
    return {
      rank: 6,
      name: "Full House",
      tiebreak: [groups[0].rank, groups[1].rank],
    };
  }

  // Flush
  if (isFlush) {
    return { rank: 5, name: "Flush", tiebreak: ranks.slice().reverse() };
  }

  // Straight
  if (isStraight !== false) {
    return { rank: 4, name: "Straight", tiebreak: [isStraight] };
  }

  // Three of a kind
  if (groups[0].count === 3) {
    return {
      rank: 3,
      name: "Three of a Kind",
      tiebreak: [
        groups[0].rank,
        ...groups
          .slice(1)
          .map((g) => g.rank)
          .sort((a, b) => b - a),
      ],
    };
  }

  // Two pair
  if (groups[0].count === 2 && groups[1].count === 2) {
    return {
      rank: 2,
      name: "Two Pair",
      tiebreak: [
        Math.max(groups[0].rank, groups[1].rank),
        Math.min(groups[0].rank, groups[1].rank),
        groups[2].rank,
      ],
    };
  }

  // One pair
  if (groups[0].count === 2) {
    return {
      rank: 1,
      name: "One Pair",
      tiebreak: [
        groups[0].rank,
        ...groups
          .slice(1)
          .map((g) => g.rank)
          .sort((a, b) => b - a),
      ],
    };
  }

  // High card
  return { rank: 0, name: "High Card", tiebreak: ranks.slice().reverse() };
}

// -----------------------
// Сравнение двух оценок
// -----------------------
function compareRanks(a, b) {
  if (a.rank !== b.rank) return a.rank - b.rank;
  for (let i = 0; i < Math.max(a.tiebreak.length, b.tiebreak.length); i++) {
    const aa = a.tiebreak[i] ?? -1;
    const bb = b.tiebreak[i] ?? -1;
    if (aa !== bb) return aa - bb;
  }
  return 0;
}

// -----------------------
// Все комбинации k из массива
// -----------------------
function combinations(arr, k) {
  const res = [];
  function rec(start, combo) {
    if (combo.length === k) {
      res.push(combo.slice());
      return;
    }
    for (let i = start; i < arr.length; i++) {
      combo.push(arr[i]);
      rec(i + 1, combo);
      combo.pop();
    }
  }
  rec(0, []);
  return res;
}
